
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { getLocale } from 'lib/utils/getLocale'

import ErrorMessageContent from './ErrorMessageContent'
import Link from 'components/Link'

const TrafiVehicleRestrictionMessage = () => {
    const { i18n } = useTranslation(['errors'])

    return (
        <ErrorMessageContent
            content={(
                <p>
                    <Trans i18nKey="errors:errorMessage.trafiGenericRestriction.hasTrafiRestriction">
                        Vehicle has Trafi restrictions which blocks selling. If needed contact our <Link to={`${getLocale(i18n.language)}/ota-yhteytta`} trackName="customerService">Customer Service</Link>.
                    </Trans>
                </p>
            )}
        />
    )
}

export default TrafiVehicleRestrictionMessage
